import { FiltroResultadoColeta } from '../comum/modelos/filtro-resultado-coleta';
import { ResultadoColeta } from '../comum/modelos/resultado-coleta';
import { SettingsService } from '../settings.service';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DetalheColeta } from '../comum/modelos/detalhe-coleta';
import { Coleta } from '../comum/modelos/coleta';
import { FiltroInconsistencia } from '../comum/modelos/filtro-inconsistencia';
import { ResultadoInconsistencia } from '../comum/modelos/resultado-inconsistencia';
import { Inconsistencia } from '../comum/modelos/inconsistencia';

@Injectable()
export class ColetaService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/coletas/';
  }

  obterResultadosColetaHttp(filtroResultadoColeta: FiltroResultadoColeta): Observable<HttpResponse<ResultadoColeta[]>> {
    return this._http.post(this._host + 'resultado/search/', filtroResultadoColeta, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterDetalhesColetasHttp(resultadoColeta: ResultadoColeta): Observable<HttpResponse<DetalheColeta[]>> {
    return this._http.post(this._host + 'detalhe/search/', resultadoColeta, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterListaColetasHttp(resultadoColeta: ResultadoColeta): Observable<HttpResponse<Coleta[]>> {
    return this._http.post(this._host + 'lista-coletas/search/', resultadoColeta, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterTotalVisitasHttp(filtroInconsistencia: FiltroInconsistencia): Observable<HttpResponse<ResultadoInconsistencia[]>> {
    return this._http.post(this._host + 'total-visitas/search/', filtroInconsistencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterTotalInconsistenciasHttp(filtroInconsistencia: FiltroInconsistencia): Observable<HttpResponse<ResultadoInconsistencia[]>> {
    return this._http.post(this._host + 'total-inconsistencias/search/', filtroInconsistencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  obterInconsistenciasHttp(resultadoInconsistencia: ResultadoInconsistencia): Observable<HttpResponse<Inconsistencia[]>> {
    return this._http.post(this._host + 'detalhe-inconsistencias/search/', resultadoInconsistencia, {
      observe: 'response'
    }).catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/coleta.service.ts